import { Component} from '@angular/core';
import {  MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardFooter, MatCardImage, MatCardModule } from '@angular/material/card';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { SafePipe } from '../../shared/pipes/safe.pipe';
import { HighchartsChartModule } from 'highcharts-angular';
import { ProjectService } from '../../services/project/project.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {  RouterModule } from '@angular/router';

interface Statistics {
  projects: number;
  zones: number;
  sensors: number;
  cameras: number;
  cards: number;
  alerts: number;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterModule, MatIconModule, MatCardModule,HighchartsChartModule, MatCard,MatCardContent,MatCardActions,MatCardFooter,MatCardImage,MatGridList,MatGridTile,MatButtonModule,SafePipe,CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})

export class DashboardComponent {

  projects:any=null;
  statistics: Statistics | null = null;

  constructor(private projectService:ProjectService){
  }

  ngOnInit() {
    this.getAllStatistics();
    // setTimeout(() => {
      this.getProjects();
    // }, 2000);
  }

  getProjects() {
    if(localStorage.getItem('ORKESTRIAUSER')){
      let user = JSON.parse(localStorage.getItem('ORKESTRIAUSER')??'');
      if (this.isAdmin()) {
        this.projectService.getAllProjects().subscribe(
          (response) => {
            this.projects = response;
          }
        );
        return;
      }
      this.projectService.getAllProjectsByUser(user.id).subscribe(
        (response) => {
          this.projects = response;
        }
      );
    }else{
      this.projectService.getAllProjects().subscribe(
        (response) => {
        this.projects = response;
        }
      );
    }


  }
  isAdmin(): boolean {
    let user= JSON.parse(localStorage.getItem('ORKESTRIAUSER')??'')
    return user.roles.some((role: any) => role.name === 'ADMIN');
  }

  getAllStatistics(){
    this.projectService.getAllStatistics().subscribe(
      (response) => {
        this.statistics = response.total;
        console.log(response);
      }
    );
  }

  goToProject(id:any){
  }

}
